import React from 'react';

/** Lädt nach, sobald das Ende des Scrollcontainers in Sichtweite kommt. */
export function useLoadMoreOnScroll(
  rootRef: React.RefObject<HTMLElement | null>,
  sentinelRef: React.RefObject<HTMLElement | null>,
  enabled: boolean,
  onReach: () => void,
) {
  React.useEffect(() => {
    const root = rootRef.current;
    const sentinel = sentinelRef.current;
    if (!enabled || !root || !sentinel) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) onReach();
      },
      { root, rootMargin: '400px' },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [rootRef, sentinelRef, enabled, onReach]);
}
